import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';

import {keycodes} from 'utilities';
import {FocusTrap} from 'components/FocusTrap';
import {Icon} from 'components/UIKit';
import {NOOP} from 'components/UIKit/utilities';
import styles from './NavSearch.scss';
import * as locales from '../../locales';

interface NavSearchProps {
  onCancel: () => any;
  onChange: (value: string) => any;
  open: boolean;
  searchAction: string;
  searchTerm?: string;
}

export class NavSearchComponent extends React.Component<NavSearchProps & WithI18nProps> {
  container: any;

  handleInputChange = (event) => {
    const {onChange = NOOP} = this.props;
    const value = event.target.value;
    onChange(value);
  };

  handleContainerKeydown = (event) => {
    if (event.which === keycodes.ESCAPE) {
      const {onCancel = NOOP} = this.props;
      event.preventDefault();
      event.stopPropagation();
      onCancel();
    }
  };

  handleContainerClick = () => {
    const {onCancel = NOOP} = this.props;
    onCancel();
  };

  handleCloseClick = (event) => {
    event.stopPropagation();

    const {onCancel = NOOP} = this.props;
    onCancel();
  };

  handleFormClick = (event) => event.stopPropagation();

  render() {
    const {
      open = false,
      searchAction,
      searchTerm,
      i18n,
    } = this.props;

    const tabIndex = open ? 0 : -1;

    /* eslint-disable */
    return (
      <FocusTrap active={open}>
        {(focusRef) => (
          <div
            ref={focusRef}
            onClick={this.handleContainerClick}
            tabIndex={-1}
            className={classNames(styles.overlay, open && styles.open)}
            onKeyDown={this.handleContainerKeydown}
          >
            <div className={styles.formContainer} onClick={this.handleFormClick}>
              <form className={styles.form} action={searchAction} method="get">
                <input
                  className={styles.field}
                  type="search"
                  name="search"
                  id="search"
                  aria-label={i18n.translate('search.search')}
                  placeholder={i18n.translate('search.search')}
                  onChange={this.handleInputChange}
                  value={searchTerm}
                  tabIndex={tabIndex}
                />

                <button
                  aria-label={i18n.translate('search.close')}
                  className={styles.close}
                  type="button"
                  tabIndex={tabIndex}
                  onClick={this.handleCloseClick}
                >
                  <Icon fill="black" icon="close" size={20} aria-hidden />
                </button>
              </form>
            </div>
          </div>
        )}
      </FocusTrap>
    );
    /* eslint-enable */
  }
}

export const NavSearch = withI18n({
  id: 'NavSearch',
  fallback: locales.en,
})(NavSearchComponent);

export default NavSearch;
